import { render, staticRenderFns } from "./LinedHeader.vue?vue&type=template&id=6d6ba80c&"
import script from "./LinedHeader.vue?vue&type=script&lang=js&"
export * from "./LinedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6ba80c')) {
      api.createRecord('6d6ba80c', component.options)
    } else {
      api.reload('6d6ba80c', component.options)
    }
    module.hot.accept("./LinedHeader.vue?vue&type=template&id=6d6ba80c&", function () {
      api.rerender('6d6ba80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/LinedHeader/LinedHeader.vue"
export default component.exports